import { Component, Input, OnInit } from '@angular/core';
import { CallCard } from '@models/imported/SagaSchema/CallCard';
import { CFreeText } from '@models/imported/SagaSchema/CFreeText';
import { ProfileReaderService } from '@services/profile-reader/profile-reader.service';

@Component({
  selector: 'app-callcard-list-free-text',
  templateUrl: './callcard-list-free-text.component.html',
  styleUrls: ['./callcard-list-free-text.component.scss']
})
export class CallcardListFreeTextComponent implements OnInit {
  @Input()
  callcard: CallCard;
  @Input()
  isMyCallcard: boolean;

  freeTexts: CFreeText[];

  private showFreeTextTypes: number[];

  constructor(private profileReader: ProfileReaderService) {}

  ngOnInit() {
    this.showFreeTextTypes = this.profileReader.getComponentConfig('listcallcards', 'showFreeTextTypes', []);
    this.freeTexts = this.callcard.component<CFreeText>(CFreeText);
  }

  filterFreeTexts(freeTexts: CFreeText[]): CFreeText[] {
    return freeTexts.filter(freeText => this.showFreeTextTypes.includes(freeText.FreeTextType));
  }
}
